import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=6637f9c1&scoped=true&"
var script = {}
import style0 from "./Modal.vue?vue&type=style&index=0&id=6637f9c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6637f9c1",
  null
  
)

export default component.exports